import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import LiquidRender, { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import $ from 'jquery';
import Client from '@gate31/uikit/common/components/client/client';
import { ModalFreeDesk } from '../ModalFreeDesk/ModalFreeDesk';
import { WelcomePopupFormDesk } from '../WelcomePopupFormDesk/WelcomePopupFormDesk';

class CreateUserModalDeskManagerDesk {
    static readonly COOKIE_KEY_NAME = 'WELCOME_MODAL_DATAS';

    static canShow() {
        const value = $ && $.cookie ? $.cookie(CreateUserModalDeskManagerDesk.COOKIE_KEY_NAME) : null;

        switch (value) {
            // Не подписался и закрыл окно
            case 'CLOSED':
                return false;
            // Подписался
            case 'SUBSCRIBED':
                return false;
            // Показываем впервые
            default:
                return true;
        }
    }

    static pause() {
        $ && $.cookie ? $.cookie(
            CreateUserModalDeskManagerDesk.COOKIE_KEY_NAME,
            'CLOSED',
            {
                expires: 4
            }
        ) : null;
    }

    static off() {
        $ && $.cookie ? $.cookie(
            CreateUserModalDeskManagerDesk.COOKIE_KEY_NAME,
            'SUBSCRIBED',
            {
                expires: 999
            }
        ) : null;
    }
}

export class CreateUserModalDesk extends BaseJs {
    static cn = new BaseJs.BuildCn('WelcomeFormCreateUser');

    title: string;
    descr: string;

    isSuccess: boolean

    modal: ModalFreeDesk;
    form: WelcomePopupFormDesk | undefined;

    constructor({ template, opts }: { template: keyof LiquidTemplates; opts: { title: string; descr: string }}) {
        super(template);

        this.title = opts.title;
        this.descr = opts.descr;

        this.isSuccess = false;

        this.modal = this.getModal();

        this.callbackConnection();
    }

    async callbackConnection() {
        const clientStatus = await Client.get().then(response => response.status);

        if (clientStatus === 'ok') {
            CreateUserModalDeskManagerDesk.off();
        }

        if (CreateUserModalDeskManagerDesk.canShow()) {
            const delayTime = Number(window.Site.settings.createUserModal.delay) || 5;

            setTimeout(() => {
                this.openModal();
            }, delayTime * 1000);
        }

        this.modal.on('close', () => {
            if (this.isSuccess) {
                this.modal.close();
                CreateUserModalDeskManagerDesk.off();
                return;
            }

            CreateUserModalDeskManagerDesk.pause();
        });
    }

    openModal() {
        this.modal.open(() => {
            this.form = new WelcomePopupFormDesk(this.getRoot().querySelector(WelcomePopupFormDesk.cn.toSelector()) as HTMLFormElement);

            this.form.ee.on('subscription-form:success', () => {
                this.isSuccess = true;
            });
        });
    }

    getModalContent() {
        return LiquidRender.render(this.template, {
            subscription_title: this.title,
            subscription_descr: this.descr || ''
        });
    }

    getModal() {
        return new ModalFreeDesk({
            template: 'modal-free-desk',
            content: this.getModalContent(),
            disableBodyScroll: true,
            viewOpts: {
                closeIconSize: 'm',
                className: 'WelcomeFormCreateUser'
            }
        });
    }
}
